import { resultSchema } from "../schema/result.schema";

export const TRANSACTIONMUTATION = `mutation ($transaction: TransactionIn!, $userId: String!, $accountName: String!, $firstName: String!, $lastName: String!, $username: String!) {
    transaction(transaction: $transaction, userId: $userId, accountName: $accountName, firstName: $firstName, lastName: $lastName, username: $username) {
    ${resultSchema}
    }
}`;


export const ADDFEEDBACKMUTATION = `mutation ($id: String!, $feedback: String!) {
    updateTransactionWithUserFeedback(id:$id, feedback: $feedback) {
        domain {
            transactionId  
            notes{
                note
            } 
        }
    }
}
`